import { jsx } from "react/jsx-runtime";
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from "chart.js";
import { Line } from "react-chartjs-2";
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);
const customLegend = {
  id: "customLegend",
  afterDraw: (chart) => {
    const {
      _metasets,
      ctx
    } = chart;
    ctx.save();
    _metasets.forEach((meta) => {
      const xPosition = meta.data[meta.data.length - 1].x + 6;
      const yPosition = meta.data[meta.data.length - 1].y;
      ctx.font = "12px Arial";
      ctx.fillText(meta._dataset.label, xPosition, yPosition);
    });
  }
};
const LineChart = ({
  chartData,
  options,
  chartRef,
  afterDrawPlugin
}) => /* @__PURE__ */ jsx(Line, { ref: chartRef, options, data: chartData, plugins: afterDrawPlugin ? [customLegend, afterDrawPlugin] : [customLegend] });
export {
  LineChart as default
};
